import { Dialog, Layout, Text } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'
import { formatCurrency } from 'core/utils/currency'

import { type QuoteStop } from '../domain/QuoteStop'
import { getPickupAndDelivery } from '../presenter/quoteStopPresenter'

export type ConfirmSubmissionDialogProps = {
  rate: number
  stops: Array<QuoteStop>
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmSubmissionDialog({
  rate,
  stops,
  onConfirm,
  onCancel,
}: ConfirmSubmissionDialogProps) {
  const { pickup, delivery } = getPickupAndDelivery(stops)

  return (
    <Dialog onOverlayClick={onCancel} scale="small" open>
      <Dialog.Header>Submit rate</Dialog.Header>
      <Dialog.Body>
        <Layout.Stack>
          <Text>Submitted rates cannot be edited</Text>
          <Layout.Group align="center" justify="center" space="xs">
            <Text>{pickup.description}</Text>
            <Icon name="arrow-right" />
            <Text>{delivery.description}</Text>
          </Layout.Group>
          <Text variant="heading-sm">
            Rate: <Text variant="heading-sm-bold">{formatCurrency(rate)}</Text>
          </Text>
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.ActionConfirm onConfirm={onConfirm}>Confirm</Dialog.ActionConfirm>
      <Dialog.ActionCancel onCancel={onCancel}>Cancel</Dialog.ActionCancel>
    </Dialog>
  )
}
